import DOMPurify from 'dompurify';

const ALLOWED_IFRAME_HOSTS = new Set([
  'cdn.embedly.com',
  'player.vimeo.com',
  'videopress.com',
  'vine.co',
  'www.youtube.com',
]);

const isAllowedIframeSrc = (src: string): boolean => {
  try {
    const { hostname, protocol } = new URL(src);
    return protocol === 'https:' && ALLOWED_IFRAME_HOSTS.has(hostname);
  } catch {
    return false;
  }
};

const EMBEDLY_DOM_PURIFY_CONFIG = {
  ALLOWED_TAGS: ['iframe'],
  ALLOWED_ATTR: [
    'allow',
    'allowfullscreen',
    'class',
    'frameborder',
    'height',
    'scrolling',
    'src',
    'title',
    'width',
  ],
  ADD_URI_SAFE_ATTR: ['src'],
};

export const sanitizeEmbedlyHtml = (html: string): string => {
  const sanitized = DOMPurify.sanitize(html || '', EMBEDLY_DOM_PURIFY_CONFIG);
  if (!sanitized) return '';

  const doc = new DOMParser().parseFromString(sanitized, 'text/html');
  const iframes = Array.from(doc.querySelectorAll('iframe'));

  iframes.forEach((iframe) => {
    const src = iframe.getAttribute('src');
    if (!src || !isAllowedIframeSrc(src)) {
      iframe.remove();
    }
  });

  return doc.body.innerHTML;
};
